export const DATE_FORMAT_DELIVERY: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
}
export const DATE_FORMAT_DEADLINE: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
}
